/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Show_In_SplitInputs */

const en_tables_rule_sets_show_in_split = /** @type {(inputs: Tables_Rule_Sets_Show_In_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Show In Split`)
};

const de_tables_rule_sets_show_in_split = /** @type {(inputs: Tables_Rule_Sets_Show_In_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Split anzeigen`)
};

/**
* | output |
* | --- |
* | "Sets Show In Split" |
*
* @param {Tables_Rule_Sets_Show_In_SplitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_show_in_split = /** @type {((inputs?: Tables_Rule_Sets_Show_In_SplitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Show_In_SplitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_show_in_split(inputs)
	return de_tables_rule_sets_show_in_split(inputs)
});